import styles from 'components/bottomArc/BottomArc.module.scss'

export const BottomArc = () => {
  return (
    <div className={styles.container}>
      <div className={styles.arcBottom} />
    </div>
  )
}
